/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Book_Appointment_ButtonInputs */

const en_candidate_book_appointment_button = /** @type {(inputs: Candidate_Book_Appointment_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book appointment`)
};

const de_candidate_book_appointment_button = /** @type {(inputs: Candidate_Book_Appointment_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termin buchen`)
};

/**
* | output |
* | --- |
* | "Book appointment" |
*
* @param {Candidate_Book_Appointment_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_book_appointment_button = /** @type {((inputs?: Candidate_Book_Appointment_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Book_Appointment_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_book_appointment_button(inputs)
	return en_candidate_book_appointment_button(inputs)
});